import Cookies from 'js-cookie'

import { AUTH_COOKIE } from '@/app/cookies'

export function getClientAuthCookieValue(): string | undefined {
  return Cookies.get(AUTH_COOKIE)
}
